/** @internal */
export function createMaxLines() {

    return {

        require: "?ngModel",
        restrict: "A",

        link: (scope, element, attr, ctrl: ng.INgModelController) => {

            var maxLines = 1;

            attr.$observe('omniaMaxLines', (val) => {
                maxLines = parseInt(val);
            });

            ctrl.$validators.maxlines = (modelValue, viewValue) => {
                var numLines = (modelValue || '').split("\n").length;
                return numLines <= maxLines;
            };

            attr.$observe('maxLinesPreventEnter', (preventEnter) => {
                // if attribute value starts with 'f', treat as false. Everything else is true
                preventEnter = (preventEnter || '').toLocaleLowerCase().indexOf('f') !== 0;
                if (preventEnter) {
                    addKeypress();
                } else {
                    removeKeypress();
                }
            });

            function addKeypress() {
                element.on('keypress', function(event) {
                    // test if adding a newline would cause the validator to fail
                    if (event.keyCode == 13 && !ctrl.$validators.maxlines(ctrl.$modelValue + '\n', ctrl.$viewValue + '\n')) {
                        event.preventDefault();
                    }
                });
            }

            function removeKeypress() {
                element.off('.maxlines');
            }

            scope.$on('$destroy', removeKeypress);

        }

    }

}
